import React, { useContext } from 'react'
import { useMutation } from '@apollo/client'
import { Button } from 'semantic-ui-react'
import MixpanelTracker from '../../utils/MixpanelTracker'
import {
  CREATE_STRIPE_LOGIN_LINK_MUTATION,
  DISCONNECT_STRIPE_MUTATION,
} from '../../graphql/stripe'
import DataContext from '../../contexts/DataContext'

const ConnectPanel = () => {
  const { advisor } = useContext(DataContext)

  const [disconnectStripe] = useMutation(DISCONNECT_STRIPE_MUTATION, {
    context: { skipGlobalErrorHandling: true },
    onCompleted: () => {
      alert('Disconnected')
      MixpanelTracker.trackDisconnectFromStripe()
      window.location.reload()
    },
    onError: (err) => alert(err.message),
  })
  const [getStripeLoginLink, { loading }] = useMutation(
    CREATE_STRIPE_LOGIN_LINK_MUTATION,
    {
      context: { skipGlobalErrorHandling: true },
      onCompleted: (data) => {
        MixpanelTracker.trackViewStripe()
        window.open(data.createStripeLoginLink)
      },
      onError: (err) => alert(err.message),
    }
  )

  return (
    <div>
      <div className="bank-section">
        <div className="connect-section transcation-section row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-12 transcation-info">
            <div className="button-part">
              <Button
                primary
                loading={loading}
                disabled={loading}
                content="View Payment Detail from Stripe"
                onClick={() => {
                  if (advisor.expert.stripeAccount.data.type === 'express') {
                    getStripeLoginLink()
                  } else {
                    window.open(
                      'https://dashboard.stripe.com/dashboard',
                      '_blank'
                    )
                  }
                }}
              />
              <br />
              <br />
              <span
                id="disconnect-stripe-btn"
                onClick={() => disconnectStripe()}
              >
                Disconnect Stripe from Dexter
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConnectPanel
